import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/esnext.global-this.js";
import React, { useEffect, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { Container, Grid, TAGTypography, FacilityContext, TAGBreadCrumbs } from '../../';
import * as templates from '../templates';
export function reloadPWA() {
  location.reload();
}
export function updateSW() {
  return _updateSW.apply(this, arguments);
}

function _updateSW() {
  _updateSW = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var sw;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!('serviceWorker' in navigator)) {
              _context.next = 6;
              break;
            }

            // reload app when controller change event occurs
            navigator.serviceWorker.addEventListener('controllerchange', reloadPWA); // get Service Worker registration and check for updates

            _context.next = 4;
            return navigator.serviceWorker.getRegistration('/sw.js');

          case 4:
            sw = _context.sent;
            // This can also be applied to a button click
            sw === null || sw === void 0 ? void 0 : sw.update();

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _updateSW.apply(this, arguments);
}

export function clearListener() {
  // clears the event listener to avoid memory leaks
  if ('serviceWorker' in navigator) navigator.serviceWorker.removeEventListener('controllerchange', reloadPWA);
}

var Page = function Page(_ref) {
  var _globalThis$location2;

  var branding = _ref.branding,
      pageData = _ref.pageData;
  var breadcrumbs = pageData.breadcrumbs,
      breadcrumbTitle = pageData.breadcrumbTitle,
      canonical = pageData.canonical,
      contents = pageData.contents,
      description = pageData.description,
      name = pageData.name,
      pageTitle = pageData.pageTitle,
      path = pageData.path,
      _pageData$personalize = pageData.personalized,
      personalized = _pageData$personalize === void 0 ? false : _pageData$personalize,
      personalizedPathPrefix = pageData.personalizedPathPrefix,
      _pageData$personalize2 = pageData.personalizedPathSuffix,
      personalizedPathSuffix = _pageData$personalize2 === void 0 ? '' : _pageData$personalize2,
      title = pageData.title;

  var _useContext = useContext(FacilityContext),
      facilityState = _useContext.state;

  useEffect(function () {
    updateSW();
    return clearListener;
  });
  useEffect(function () {
    var _globalThis$Invoca, _globalThis$Invoca$PN;

    if (personalized && personalizedPathPrefix && facilityState.address) {
      var _facilityState$addres, _facilityState$addres2, _facilityState$addres3, _facilityState$addres4, _facilityState$addres5, _facilityState$addres6;

      var state = (_facilityState$addres = facilityState.address) === null || _facilityState$addres === void 0 ? void 0 : (_facilityState$addres2 = _facilityState$addres.state) === null || _facilityState$addres2 === void 0 ? void 0 : _facilityState$addres2.toLowerCase();
      var city = (_facilityState$addres3 = facilityState.address) === null || _facilityState$addres3 === void 0 ? void 0 : (_facilityState$addres4 = _facilityState$addres3.city) === null || _facilityState$addres4 === void 0 ? void 0 : _facilityState$addres4.toLowerCase().replace(/ /gi, '-');
      var line1 = (_facilityState$addres5 = facilityState.address) === null || _facilityState$addres5 === void 0 ? void 0 : (_facilityState$addres6 = _facilityState$addres5.line1) === null || _facilityState$addres6 === void 0 ? void 0 : _facilityState$addres6.toLowerCase().replace(/ /gi, '-').replace(/[,\.]/gi, ''); // this is hash value

      var pathSuffix = personalizedPathSuffix.toLowerCase().replace(/ /gi, '-').replace(/ & /gi, '-');
      var personalizedUrl = "".concat(globalThis.location.origin).concat(personalizedPathPrefix, "/").concat(state, "/").concat(city, "/").concat(line1, "#").concat(pathSuffix); // redirect user to personalized page

      globalThis.location.href = personalizedUrl;
    }

    if (globalThis.Invoca) (_globalThis$Invoca = globalThis.Invoca) === null || _globalThis$Invoca === void 0 ? void 0 : (_globalThis$Invoca$PN = _globalThis$Invoca.PNAPI) === null || _globalThis$Invoca$PN === void 0 ? void 0 : _globalThis$Invoca$PN.run();
  }, [facilityState]);
  var ListItems = breadcrumbs !== null && breadcrumbs !== void 0 && breadcrumbs.length ? breadcrumbs.map(function (breadcrumb, index) {
    var _globalThis$location;

    return {
      position: index + 1,
      '@type': 'ListItem',
      item: {
        '@id': "".concat(globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.origin).concat(breadcrumb.path),
        name: "".concat(breadcrumb.breadcrumbTitle)
      }
    };
  }) : [];
  return React.createElement(React.Fragment, null, React.createElement(Helmet, {
    defer: false
  }, React.createElement("title", null, title), React.createElement("meta", {
    name: "description",
    content: description
  }), canonical ? React.createElement("link", {
    rel: "canonical",
    href: canonical
  }) : React.createElement("link", {
    rel: "canonical",
    href: path
  }), React.createElement("script", {
    type: "application/ld+json"
  }, "{\n            \"@context\": \"http://schema.org\",\n            \"@type\": \"WPHeader\",\n            \"headline\": \"".concat(title, "\",\n            \"description\": \"").concat(description, "\"\n          }")), React.createElement("script", {
    type: "application/ld+json"
  }, "{\n            \"@context\": \"http://www.schema.org\",\n            \"@type\": \"WebPage\",\n            \"name\": \"".concat(name, "\",\n            \"url\": \"").concat(globalThis === null || globalThis === void 0 ? void 0 : globalThis.location.href, "\",\n            \"description\" : \"").concat(description, "\"\n          }")), (breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length) && React.createElement("script", {
    type: "application/ld+json"
  }, "{\n              \"@context\": \"http://schema.org\",\n              \"@type\": \"BreadcrumbList\",\n              \"itemListElement\": ".concat(JSON.stringify(ListItems.concat([{
    position: ListItems.length + 1,
    '@type': 'ListItem',
    item: {
      '@id': "".concat(globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$location2 = globalThis.location) === null || _globalThis$location2 === void 0 ? void 0 : _globalThis$location2.href),
      name: "".concat(breadcrumbTitle)
    }
  }])), "\n            }"))), breadcrumbs && React.createElement(Container, null, React.createElement(Grid, {
    container: true,
    alignItems: "center",
    wrap: "nowrap",
    mt: 2,
    mb: 2
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGBreadCrumbs, {
    pageData: pageData
  })))), pageTitle && React.createElement(Container, null, React.createElement(Grid, {
    container: true,
    alignItems: "center",
    wrap: "nowrap"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    variant: "h1",
    color: "primary"
  }, pageTitle)))), contents && contents.map(function (content, index) {
    var _content$branding;

    return content.__typename && templates[content.__typename.slice(10)] && React.createElement(templates[content.__typename.slice(10)], _objectSpread(_objectSpread({}, content), {}, {
      branding: (_content$branding = content.branding) !== null && _content$branding !== void 0 ? _content$branding : branding,
      key: "".concat(content.contentful_id, "-pageContent").concat(index)
    }));
  }));
};

export default Page;